module.exports = __webpack_public_path__ + "static/media/icon_findmap.9040fd2c.svg";